<template>
  <ContentSection :spacing="conditionalSpacing">
    <Container
      class="px-container lg:px-container-wide xl:px-container-desktop-wide"
    >
      <div class="grid grid-cols-1 gap-7 sm:gap-10 lg:grid-cols-2 lg:gap-12">
        <!-- TEXT -->
        <div
          class="px-4 lg:px-6 lg:pt-4"
          :class="data.layout.value === 'right' ? 'order-1' : 'order-2'"
        >
          <div
            v-if="data.text"
            class="text-link prose sm:prose-big sm:text-md"
            v-html="data.text"
          />
        </div>

        <!-- IMAGE OR VIDEO -->
        <div
          class="relative h-full w-full"
          :class="data.layout.value === 'right' ? 'order-2' : 'order-1'"
        >
          <AppImage
            v-if="imageOrVideo.image"
            :src="imageOrVideo.image"
            :alt="
              $i18n.locale === 'fr'
                ? imageOrVideo.image.alt_fr
                : imageOrVideo.image.alt
            "
            loading="lazy"
          />

          <VideoPlayer
            v-else-if="imageOrVideo.video"
            :src="imageOrVideo.video"
            class="aspect-video w-full bg-blue-dark-500"
            :cover-image="imageOrVideo.cover_image"
            :youtube="{ controls: 1 }"
            keep-aspect-video
          />
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: null },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})

const imageOrVideo = computed(() => {
  return props.data?.image_or_video?.[0] || {}
})

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
  ['custom_text', 'text_and_image_or_video']
)
</script>
